import { render, staticRenderFns } from "./BusinessSegmentModal.vue?vue&type=template&id=8e83d232&"
import script from "./BusinessSegmentModal.vue?vue&type=script&lang=js&"
export * from "./BusinessSegmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports